export default "__VITE_ASSET__CRidl9Jj__"